import $ from 'jquery';

export function initMobileMenu() {
  const swishyMemu = $('.js-swisyMobileMenu');
  swishyMemu.click(function(e) {
    e.preventDefault();
    swishyMemu.toggleClass('open');

    // $('body').toggleClass("no-scroll");

    $(".js-l-mobile").toggle();
  });
} 
